import React from 'react';
import CollapsibleHelp from '../../components/CollapsibleHelp';
import MppField from './MppField';
import { COPY_EDIT_SECTIONS, RETURNING_COPY_SUGGESTIONS } from './marketingPopupCopySections';

function PhaseToggle({ phase, onChange }) {
  return (
    <div className="mpp-copy-phase-nav" role="tablist" aria-label="Pop-up of bedankt-scherm">
      <button
        type="button"
        role="tab"
        aria-selected={phase === 'form'}
        className={phase === 'form' ? 'active' : ''}
        onClick={() => onChange('form')}
      >
        Pop-up
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={phase === 'success'}
        className={phase === 'success' ? 'active' : ''}
        onClick={() => onChange('success')}
      >
        Bedankt
      </button>
    </div>
  );
}

export default function MarketingPopupCopyTab({
  config,
  setConfig,
  editSection,
  editPhase,
  onEditSectionChange,
  onEditPhaseChange,
}) {
  const set = (patch) => setConfig((c) => ({ ...c, ...patch }));
  const section = editSection || 'welcome';
  const phase = editPhase === 'success' ? 'success' : 'form';
  const hasReturningOffer =
    (parseFloat(config?.returning_coupon_fixed_eur) || 0) > 0 || (config?.returning_coupon_percent || 0) > 0;

  const applyReturningSuggestions = () => {
    set({ ...RETURNING_COPY_SUGGESTIONS });
  };

  return (
    <div className="marketing-popup-copy">
      <label className="marketing-ig-checkbox mpp-card-toggle mpp-card-toggle--primary">
        <input type="checkbox" checked={!!config?.enabled} onChange={(e) => set({ enabled: e.target.checked })} />
        Pop-up actief op webshop (kortingscodes + volledige flow)
      </label>

      <label className="marketing-ig-checkbox mpp-card-toggle mpp-card-toggle--capture">
        <input
          type="checkbox"
          checked={!!config?.lead_capture_enabled}
          onChange={(e) => set({ lead_capture_enabled: e.target.checked })}
        />
        Alleen e-mail verzamelen (zonder kortings-pop-up)
      </label>

      <div className="mpp-copy-section-nav" role="tablist" aria-label="Welk pop-uptype bewerken">
        {COPY_EDIT_SECTIONS.map((s) => (
          <button
            key={s.id}
            type="button"
            role="tab"
            aria-selected={section === s.id}
            className={section === s.id ? 'active' : ''}
            onClick={() => onEditSectionChange(s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>

      {section === 'welcome' ? (
        <section className="mpp-card mpp-card--wide">
          <PhaseToggle phase={phase} onChange={onEditPhaseChange} />

          {phase === 'form' ? (
            <>
              <MppField label="Korting (%)">
                <input
                  type="number"
                  className="form-input"
                  min={1}
                  max={25}
                  value={config?.welcome_percent ?? 7}
                  onChange={(e) => set({ welcome_percent: Number(e.target.value) })}
                />
              </MppField>
              <MppField label="Titel">
                <input
                  className="form-input"
                  value={config?.title_welcome || ''}
                  onChange={(e) => set({ title_welcome: e.target.value })}
                />
              </MppField>
              <MppField label="Tekst">
                <textarea
                  className="form-input"
                  rows={3}
                  value={config?.body_welcome || ''}
                  onChange={(e) => set({ body_welcome: e.target.value })}
                />
              </MppField>
              <MppField label="Knop">
                <input
                  className="form-input"
                  value={config?.button_welcome || ''}
                  onChange={(e) => set({ button_welcome: e.target.value })}
                />
              </MppField>
              <label className="marketing-ig-checkbox mpp-card-checkbox">
                <input
                  type="checkbox"
                  checked={!!config?.coupon_email_restriction}
                  onChange={(e) => set({ coupon_email_restriction: e.target.checked })}
                />
                Kortingscode alleen op inschrijf-e-mail (Woo-restrictie)
              </label>
              <CollapsibleHelp title="Waardebon in winkelmandje">
                <p>
                  Met e-mailrestrictie aan krijgen klanten in het mandje de melding dat ze eerst een e-mail moeten
                  invullen bij afrekenen. Standaard <strong>uit</strong>.
                </p>
              </CollapsibleHelp>
            </>
          ) : (
            <>
              <MppField label="Titel">
                <input
                  className="form-input"
                  value={config?.success_title || ''}
                  onChange={(e) => set({ success_title: e.target.value })}
                />
              </MppField>
              <MppField label="Tekst als code in winkelmand staat">
                <textarea
                  className="form-input"
                  rows={3}
                  value={config?.success_body_applied || ''}
                  onChange={(e) => set({ success_body_applied: e.target.value })}
                />
              </MppField>
              <MppField label="Tekst als klant zelf moet plakken">
                <textarea
                  className="form-input"
                  rows={3}
                  value={config?.success_body || ''}
                  onChange={(e) => set({ success_body: e.target.value })}
                />
              </MppField>
              <MppField label="Titel als e-mail al ingeschreven was">
                <input
                  className="form-input"
                  value={config?.success_already_title || ''}
                  onChange={(e) => set({ success_already_title: e.target.value })}
                />
              </MppField>
              <MppField label="Label boven kortingscode">
                <input
                  className="form-input"
                  value={config?.success_code_label || ''}
                  onChange={(e) => set({ success_code_label: e.target.value })}
                />
              </MppField>
              <MppField label="Knop kopiëren">
                <input
                  className="form-input"
                  value={config?.success_copy_button || ''}
                  onChange={(e) => set({ success_copy_button: e.target.value })}
                />
              </MppField>
              <MppField label="Tekst na kopiëren">
                <input
                  className="form-input"
                  value={config?.success_copied_button || ''}
                  onChange={(e) => set({ success_copied_button: e.target.value })}
                />
              </MppField>
            </>
          )}
        </section>
      ) : null}

      {section === 'returning' ? (
        <section className="mpp-card mpp-card--wide">
          <PhaseToggle phase={phase} onChange={onEditPhaseChange} />

          {phase === 'form' ? (
            <>
              <label className="marketing-ig-checkbox mpp-card-checkbox">
                <input
                  type="checkbox"
                  checked={!!config?.show_for_returning_customers}
                  onChange={(e) => set({ show_for_returning_customers: e.target.checked })}
                />
                Toon pop-up voor bekende kopers
              </label>

              <div className="mpp-subsection">
                <h5 className="mpp-subsection-title">Aanbod</h5>
                <MppField label="Min. dagen sinds laatste bestelling" hint="0 = meteen. 30 ≈ één maand.">
                  <input
                    type="number"
                    className="form-input"
                    min={0}
                    max={730}
                    value={config?.returning_min_days_since_order ?? 30}
                    onChange={(e) => set({ returning_min_days_since_order: Number(e.target.value) })}
                  />
                </MppField>
                <MppField label="Vaste korting (€)" hint="Gaat vóór %. Zet op 10 voor €10 in Woo.">
                  <input
                    type="number"
                    className="form-input"
                    min={0}
                    max={500}
                    step={0.01}
                    value={config?.returning_coupon_fixed_eur ?? 0}
                    onChange={(e) => set({ returning_coupon_fixed_eur: parseFloat(e.target.value) || 0 })}
                  />
                </MppField>
                <MppField label="Korting terugkerend (%)">
                  <input
                    type="number"
                    className="form-input"
                    min={0}
                    max={25}
                    value={config?.returning_coupon_percent ?? 0}
                    onChange={(e) => set({ returning_coupon_percent: Number(e.target.value) })}
                  />
                </MppField>
                {hasReturningOffer ? (
                  <MppField label="Prefix kortingscode">
                    <input
                      className="form-input"
                      value={config?.returning_coupon_prefix || 'TERUG'}
                      onChange={(e) => set({ returning_coupon_prefix: e.target.value })}
                    />
                  </MppField>
                ) : null}
                <MppField label="Min. besteding voor korting (€)" hint="0 = geen minimum.">
                  <input
                    type="number"
                    className="form-input"
                    min={0}
                    step={0.01}
                    value={config?.returning_min_order_amount ?? 0}
                    onChange={(e) => set({ returning_min_order_amount: parseFloat(e.target.value) || 0 })}
                  />
                </MppField>
                <MppField label="Regel onder pop-uptekst" hint="Gebruik {min} voor bedrag.">
                  <input
                    className="form-input"
                    value={config?.returning_min_order_hint || 'Bij bestelling vanaf € {min}'}
                    onChange={(e) => set({ returning_min_order_hint: e.target.value })}
                  />
                </MppField>
              </div>

              {hasReturningOffer ? (
                <div className="mpp-subsection">
                  <h5 className="mpp-subsection-title">Teksten (met korting)</h5>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm mpp-suggest-btn"
                    onClick={applyReturningSuggestions}
                  >
                    Vul suggesties
                  </button>
                  <MppField label="Tekst naast badge (optioneel)" hint="Leeg = alleen €/% cirkel.">
                    <input
                      className="form-input"
                      value={config?.returning_offer_kicker ?? ''}
                      onChange={(e) => set({ returning_offer_kicker: e.target.value })}
                    />
                  </MppField>
                  <MppField label="Regel onder badge">
                    <input
                      className="form-input"
                      value={config?.returning_offer_sub || 'Eén klik — korting direct in je winkelmand'}
                      onChange={(e) => set({ returning_offer_sub: e.target.value })}
                    />
                  </MppField>
                  <MppField label="Bevestiging e-mail (herkend)" hint="Compact: “Korting voor …”">
                    <input
                      className="form-input"
                      value={config?.returning_known_label || 'Korting voor'}
                      onChange={(e) => set({ returning_known_label: e.target.value })}
                    />
                  </MppField>
                  <MppField label="Titel">
                    <input
                      className="form-input"
                      value={config?.title_returning_offer || ''}
                      onChange={(e) => set({ title_returning_offer: e.target.value })}
                    />
                  </MppField>
                  <MppField label="Tekst">
                    <textarea
                      className="form-input"
                      rows={4}
                      value={config?.body_returning_offer || ''}
                      onChange={(e) => set({ body_returning_offer: e.target.value })}
                    />
                  </MppField>
                  <MppField label="Knop">
                    <input
                      className="form-input"
                      value={config?.button_returning_offer || ''}
                      onChange={(e) => set({ button_returning_offer: e.target.value })}
                    />
                  </MppField>
                </div>
              ) : (
                <div className="mpp-subsection">
                  <h5 className="mpp-subsection-title">Teksten (zonder korting)</h5>
                  <p className="muted mpp-copy-section-hint">
                    Geen €/% → bekende kopers zien deze nieuwsbrief-pop-up. Bedankt-scherm = Nieuwe bezoeker →
                    Bedankt.
                  </p>
                  <MppField label="Titel">
                    <input
                      className="form-input"
                      value={config?.title_newsletter || ''}
                      onChange={(e) => set({ title_newsletter: e.target.value })}
                    />
                  </MppField>
                  <MppField label="Tekst">
                    <textarea
                      className="form-input"
                      rows={3}
                      value={config?.body_newsletter || ''}
                      onChange={(e) => set({ body_newsletter: e.target.value })}
                    />
                  </MppField>
                  <MppField label="Knop">
                    <input
                      className="form-input"
                      value={config?.button_newsletter || ''}
                      onChange={(e) => set({ button_newsletter: e.target.value })}
                    />
                  </MppField>
                </div>
              )}
            </>
          ) : (
            <>
              <label className="marketing-ig-checkbox mpp-card-checkbox">
                <input
                  type="checkbox"
                  checked={config?.success_auto_apply_cart !== false}
                  onChange={(e) => set({ success_auto_apply_cart: e.target.checked })}
                />
                Kortingscode automatisch in Woo-winkelmand zetten
              </label>
              <button
                type="button"
                className="btn btn-secondary btn-sm mpp-suggest-btn"
                onClick={applyReturningSuggestions}
              >
                Vul suggesties bedankt-scherm
              </button>
              <MppField label="Titel">
                <input
                  className="form-input"
                  value={config?.success_title_returning || ''}
                  onChange={(e) => set({ success_title_returning: e.target.value })}
                />
              </MppField>
              <MppField label="Tekst als korting in winkelmand staat">
                <textarea
                  className="form-input"
                  rows={4}
                  value={config?.success_body_applied_returning || ''}
                  onChange={(e) => set({ success_body_applied_returning: e.target.value })}
                />
              </MppField>
              <MppField label="Tekst als klant zelf moet plakken">
                <textarea
                  className="form-input"
                  rows={3}
                  value={config?.success_body_returning || ''}
                  onChange={(e) => set({ success_body_returning: e.target.value })}
                />
              </MppField>
            </>
          )}
        </section>
      ) : null}

      {section === 'form' ? (
        <section className="mpp-card mpp-card--wide">
          <MppField label="Label naam">
            <input
              className="form-input"
              value={config?.name_label || ''}
              onChange={(e) => set({ name_label: e.target.value })}
            />
          </MppField>
          <MppField label="Placeholder naam">
            <input
              className="form-input"
              value={config?.name_placeholder || ''}
              onChange={(e) => set({ name_placeholder: e.target.value })}
            />
          </MppField>
          <label className="marketing-ig-checkbox mpp-card-checkbox">
            <input
              type="checkbox"
              checked={config?.name_required !== false}
              onChange={(e) => set({ name_required: e.target.checked })}
            />
            Naam verplicht
          </label>
        </section>
      ) : null}

      {section === 'consent' ? (
        <section className="mpp-card mpp-card--wide">
          <MppField label="Tekst bij checkbox">
            <textarea
              className="form-input"
              rows={4}
              value={config?.consent_text || ''}
              onChange={(e) => set({ consent_text: e.target.value })}
            />
          </MppField>
        </section>
      ) : null}
    </div>
  );
}
